import { useEffect, useRef, useState } from 'react';
import { getTrans, TranslationKey } from 'modules/i18n';
import { getErrorContent } from 'utils/api';

/**
 * Maps a failed availability call to user copy: the API error code's title key
 * when we have a translation for it, a generic fallback otherwise.
 */
export const apiErrorMessage = (responseError: unknown): string => {
  const content = getErrorContent(responseError);
  const translated = content.code
    ? getTrans(content.title as TranslationKey)
    : '';
  return translated || getTrans('availabilityPage.error.generic');
};

/** Self-hiding confirmation toast state for the module's ToastPill. */
export const useToast = (duration = 2000) => {
  const [message, setMessage] = useState<string | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  const showToast = (text: string) => {
    clearTimeout(timeoutRef.current);
    setMessage(text);
    timeoutRef.current = setTimeout(() => setMessage(null), duration);
  };

  return { toastMessage: message, showToast };
};
